// import { v4 as uuidv4 } from 'uuid';
// import verifyDeliveryDetails from '~/utils/verifyDeliveryDetails';
// import verifyBillingDetails from '~/utils/verifyBillingDetails';

export const useCartStore = defineStore('cart', () => {
  // const { $pb } = useNuxtApp();
  const dataStore = useDataStore();
  const DB = useDbStore();

  // console.log(dataStore.orders);
  // const storedList = useLocalStorage<Record<string, OrderI>>('cartList', {}, { initOnMounted: true });

  // const localeList = ref<Record<string, OrderI>>(storedList.value || {});

  const list = computed(() => {
    return [...Object.values(dataStore.localOrders), ...dataStore.cartOrders].sort((a, b) => {
      return new Date(a.created).getTime() - new Date(b.created).getTime();
    });
  });
  // watch(storedList, (newValue) => {
  //   localeList.value = newValue;
  // }, { deep: true });

  const discount = ref(0);

  const createOrder = async (item: ItemI, options: Partial<ServerOrderI> = {}) => {
    return dataStore.createOrder(item, options);

    // const localId = uuidv4();
    //
    // const user = dataStore.user;
    // const stickers = [...item.defaultStickers];
    //
    // const order: ServerOrderI = {
    //   localId,
    //   itemName: item.name,
    //   itemType: item.type,
    //   customizer: {
    //     stickers,
    //     lines: [],
    //     pencils: [],
    //     comment: '',
    //   },
    //   comment: 'comment',
    //   patient: 'some patient',
    //   file: null,
    //   approved: false,
    //   deliveryDetails: verifyDeliveryDetails(user?.deliveryDetails),
    //   billingDetails: verifyBillingDetails(user?.billingDetails),
    //   totalPrice: calculateOrderPrice({
    //     stickers,
    //     item,
    //   }),
    //   paid: 0,
    //   discount: 0,
    //   status: 'cart',
    //
    //   user: user?.id,
    //   ...options,
    // };
    //
    // console.log(order);
    //
    // const sOrder = await DB.createOrder(order);
    // console.log('ORDER FROM SERVER AFTER CREate', sOrder);
    //
    // dataStore.setOrder(sOrder);
    // return sOrder;
    // .then((e) => {
    //   console.info('order created', e);
    // })
    // .catch((e) => {
    //   console.log('order created error', e);
    // });
  };

  const updateOrder = async (id: string, options: Partial<ServerOrderI> = {}) => {
    const order = getUserOrderById(id);

    if (order) {
      return DB.updateOrder(order.id, { ...convertOrderToServerOrder(order), ...options });
    }

    // .then(e => console.log(e))
    // .catch(e => console.log(e));
  };

  const addFilesToOrder = async (id: string, files: File[]) => {
    const order = getUserOrderById(id);
    if (order) {
      return await DB.addOrderFiles(id, files);
    }

    const localOrder = getLocalItemByLocalId(id);
    if (localOrder) {
      localOrder.files = [...localOrder.files, ...files];

      // console.log(localOrder.files);
      // files.forEach((file) => {
      //   localOrder.files.push(file);
      // });
      // console.log('localOrder', id, localOrder);
      return localOrder;
    }
  };

  const removeFile = async (id: string, file: string | File) => {
    const order = getUserOrderById(id);
    if (order) {
      return await DB.removeOrderFile(id, file as string);
    }

    const localOrder = getLocalItemByLocalId(id);
    localOrder.files = localOrder.files.filter(f => f !== file);

    // console.log(localOrder);

    return localOrder;
  };

  const getLocalItemByLocalId = (id: string) => {
    return dataStore.localOrders[id];
  };

  const getUserOrderById = (id: string) => {
    return dataStore.orders[id];
  };

  const getItemById = (id: string) => {
    const dbOrder = getUserOrderById(id);
    if (dbOrder) return dbOrder;
    const localOrder = getLocalItemByLocalId(id);
    if (localOrder) return localOrder;

    console.info('no order with id: ', id);
    return null as unknown as OrderI;
    // return list.value.find(item => item.id === id) as OrderI;
  };

  const hasItem = (id: string) => {
    return !!getItemById(id);
  };

  const removeItem = async (id: string) => {
    // TODO: check if rewrite is needed
    const dbOrder = dataStore.orders[id];
    if (dbOrder) return DB.deleteOrder(id);

    if (dataStore.localOrders[id]) delete dataStore.localOrders[id];
  };

  // const goToPayment = async () => {
  //   const orders = list.value.map(id => getItemById(id));
  //   if (orders.length !== list.value.length) {
  //     console.error('Some orders are missing');
  //     return;
  //   }
  //
  //   const promises = [];
  //   let totalMoney = 0;
  //   let maxDiscount = discount.value;
  //   let totalDiscount = 0;
  //
  //   orders.forEach((order) => {
  //     const applicableDiscount = maxDiscount > order.totalPrice ? order.totalPrice : maxDiscount;
  //     const priceAfterDiscount = order.totalPrice - applicableDiscount;
  //     maxDiscount -= applicableDiscount;
  //
  //     order.discount = applicableDiscount;
  //     order.paid = true;
  //     // TODO move to PB hooks on pay
  //     // console.log('paid', order.paid);
  //     totalMoney += priceAfterDiscount;
  //     totalDiscount += applicableDiscount;
  //
  //     if (order.status === 'cart') {
  //       console.log('wrong status for payment');
  //
  //       order.status = 'inbox';
  //       const promise = updateOrder(order.id);
  //       promises.push(promise);
  //     }
  //   });
  //
  //   discount.value = discount.value - totalDiscount;
  //
  //   const user = dataStore.user;
  //   const cash = user?.cash || 0;
  //   const totalCash = cash + totalMoney / 10 - totalDiscount;
  //
  //   // console.log('totalMoney', totalMoney);
  //   // console.log('totalDiscount', totalDiscount);
  //   // console.log('totalCash', totalCash);
  //   const pr = DB.updateUserData({ cash: totalCash });
  //   pr.catch((e) => {
  //     console.error('error updating user cash', e);
  //     return e;
  //   });
  //   promises.push(pr);
  //   return Promise.all(promises);
  // };

  const hasItemsAndApproved = computed(() => {
    return list.value.length > 0
      && list.value.every(c => c.approved)
      && list.value.every(c => c.id || c.localId);
  });

  const canPay = computed(() => {
    return dataStore.user
      && hasItemsAndApproved.value;
  });

  return {
    list,
    discount,
    hasItemsAndApproved,
    canPay,
    // createCartItem,
    createOrder,
    updateOrder,
    addFilesToOrder,
    removeFile,

    hasItem,
    getItemById,
    removeItem,
    // goToPayment,
  };
});
